module.exports = __webpack_public_path__ + "media/10x25.6354a662.png";